module.exports = {"data":{"site":{"siteMetadata":{"title":"Mathurah Ravigulan","description":"Website porfolio for mathu","keywords":"mathurah"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 102
// module chunks = 60335399758886 114276838955818